import { render, staticRenderFns } from "./ProductDetailView.vue?vue&type=template&id=43657526&scoped=true"
import script from "./ProductDetailView.vue?vue&type=script&lang=js"
export * from "./ProductDetailView.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailView.vue?vue&type=style&index=0&id=43657526&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43657526",
  null
  
)

export default component.exports